import script from "./AccountActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountActivation.vue?vue&type=script&setup=true&lang=js"

import "./AccountActivation.vue?vue&type=style&index=0&id=5d068bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d068bbc"]])

export default __exports__